import React from 'react';
import { useApp } from '../../context/AppContext';

const Dashboard = () => {
    const { articles, videos } = useApp();

    // Calculate total views from articles and videos
    const totalArticleViews = articles.reduce((sum, article) => sum + (article.views || 0), 0);
    const totalVideoViews = videos.reduce((sum, video) => sum + (video.views || 0), 0);
    const totalViews = totalArticleViews + totalVideoViews;

    const breakingCount = articles.filter(a => a.breaking === 'yes').length;
    const featuredCount = articles.filter(a => a.featured === 'yes').length;
    const recentItems = [...articles, ...videos].sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)).slice(0, 10);

    return (
        <div>
            {/* Changed grid from repeat(4,1fr) to repeat(5,1fr) for 5 cards */}
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(5,1fr)', gap: '16px', marginBottom: '24px' }}>
                {/* Card 1: Total Articles */}
                <div style={{ background: '#fff', borderRadius: '8px', padding: '20px', textAlign: 'center', borderTop: '4px solid var(--red)' }}>
                    <div style={{ fontSize: '42px', fontWeight: 'bold', color: 'var(--navy)' }}>{articles.length}</div>
                    <div style={{ fontSize: '12px', color: '#888', marginTop: '4px' }}>Total Articles</div>
                </div>

                {/* Card 2: Total Videos */}
                <div style={{ background: '#fff', borderRadius: '8px', padding: '20px', textAlign: 'center', borderTop: '4px solid var(--navy)' }}>
                    <div style={{ fontSize: '42px', fontWeight: 'bold', color: 'var(--navy)' }}>{videos.length}</div>
                    <div style={{ fontSize: '12px', color: '#888', marginTop: '4px' }}>Total Videos</div>
                </div>

                {/* Card 3: Breaking News */}
                <div style={{ background: '#fff', borderRadius: '8px', padding: '20px', textAlign: 'center', borderTop: '4px solid var(--orange)' }}>
                    <div style={{ fontSize: '42px', fontWeight: 'bold', color: 'var(--navy)' }}>{breakingCount}</div>
                    <div style={{ fontSize: '12px', color: '#888', marginTop: '4px' }}>Breaking News</div>
                </div>

                {/* Card 4: Featured Stories */}
                <div style={{ background: '#fff', borderRadius: '8px', padding: '20px', textAlign: 'center', borderTop: '4px solid #1a7431' }}>
                    <div style={{ fontSize: '42px', fontWeight: 'bold', color: 'var(--navy)' }}>{featuredCount}</div>
                    <div style={{ fontSize: '12px', color: '#888', marginTop: '4px' }}>Featured Stories</div>
                </div>

                {/* Card 5: Total Views - NEW */}
                <div style={{ background: '#fff', borderRadius: '8px', padding: '20px', textAlign: 'center', borderTop: '4px solid var(--gold)' }}>
                    <div style={{ fontSize: '42px', fontWeight: 'bold', color: 'var(--navy)' }}>{totalViews.toLocaleString()}</div>
                    <div style={{ fontSize: '12px', color: '#888', marginTop: '4px' }}>Total Views</div>
                    <div style={{ fontSize: '10px', color: '#aaa', marginTop: '4px' }}>
                        📰 {totalArticleViews.toLocaleString()} article views
                        <br />
                        🎬 {totalVideoViews.toLocaleString()} video views
                    </div>
                </div>
            </div>

            <div style={{ background: '#fff', borderRadius: '8px', padding: '24px', boxShadow: '0 1px 6px rgba(0,0,0,.08)' }}>
                <h3 style={{ fontSize: '20px', marginBottom: '18px', color: 'var(--navy)' }}>Recent Activity</h3>
                <div style={{ overflowX: 'auto' }}>
                    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                        <thead>
                            <tr style={{ background: 'var(--navy)', color: '#fff' }}>
                                <th style={{ padding: '10px 12px', textAlign: 'left' }}>Title</th>
                                <th style={{ padding: '10px 12px', textAlign: 'left' }}>Type</th>
                                <th style={{ padding: '10px 12px', textAlign: 'left' }}>Category</th>
                                <th style={{ padding: '10px 12px', textAlign: 'left' }}>Views</th>
                                <th style={{ padding: '10px 12px', textAlign: 'left' }}>Date</th>
                            </tr>
                        </thead>
                        <tbody>
                            {recentItems.map((item, idx) => (
                                <tr key={idx}>
                                    <td style={{ padding: '10px 12px', borderBottom: '1px solid #f0f0f0' }}>{item.title?.substring(0, 60)}...</td>
                                    <td style={{ padding: '10px 12px', borderBottom: '1px solid #f0f0f0' }}>{item.url ? '📹 Video' : '📰 Article'}</td>
                                    <td style={{ padding: '10px 12px', borderBottom: '1px solid #f0f0f0' }}>{item.category || '—'}</td>
                                    <td style={{ padding: '10px 12px', borderBottom: '1px solid #f0f0f0' }}>
                                        <strong>{(item.views || 0).toLocaleString()}</strong>
                                    </td>
                                    <td style={{ padding: '10px 12px', borderBottom: '1px solid #f0f0f0' }}>{item.date}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default Dashboard;